import { FC } from 'react';
import { Box, Popper, Typography, MenuItem } from '@mui/material';
import { FileVariantsEnum, UserDto } from '@sweatpals/shared';
import { LogoutIcon, MobileIcon, PresentationIcon, RepeatIcon, UsersIcon } from '../../../icons';
import { UserAvatar } from '../../user-avatar';
import { RainbowButton } from '../../buttons';
import {
	contentStyles,
	createButtonStyles,
	currentUserFullNameStyles,
	currentUserStyles,
	menuItemStyles,
	popperStyles,
	newFeatureLabelStyles,
} from './mobile-user-profile-menu.styles';

export interface MobileUserProfileMenuProps {
	open: boolean;
	currentUser?: UserDto | null;
	anchorEl: HTMLElement | null;

	getPublicFileUrl(fileId: string, variant?: FileVariantsEnum): string;
	openDashboardPage?(): void;
	openCreateCommunityPage?(): void;
	openCreateEventPage?(): void;
	openDownloadAppPage?(): void;
	handleLogout?(): void;
	openBookDemoPage?(): void;
}

export const MobileUserProfileMenu: FC<MobileUserProfileMenuProps> = (props) => {
	const {
		open,
		currentUser,
		getPublicFileUrl,
		openDashboardPage,
		openCreateCommunityPage,
		openDownloadAppPage,
		openCreateEventPage,
		handleLogout,
		openBookDemoPage,
	} = props;

	return (
		<Popper open={open} sx={popperStyles}>
			{currentUser && (
				<Box sx={currentUserStyles}>
					<UserAvatar
						fullName={currentUser.fullName}
						avatarSrc={currentUser.avatarId && getPublicFileUrl(currentUser.avatarId, FileVariantsEnum.XS)}
						emptyAvatarVariant={currentUser.emptyAvatarVariant}
						sx={{ width: '32px', height: '32px' }}
					/>
					<Typography sx={currentUserFullNameStyles}>{currentUser?.fullName ?? currentUser?.userName}</Typography>
				</Box>
			)}
			<Box sx={contentStyles}>
				<Box>
					<MenuItem sx={menuItemStyles} onClick={openDashboardPage}>
						<RepeatIcon />
						Switch to hosting
					</MenuItem>
					<MenuItem sx={menuItemStyles} onClick={openCreateCommunityPage}>
						<UsersIcon />
						Create Community
					</MenuItem>
					<MenuItem sx={menuItemStyles} onClick={openBookDemoPage}>
						<PresentationIcon />
						Book a demo
						<Box component="label" sx={newFeatureLabelStyles}>
							New
						</Box>
					</MenuItem>
					<MenuItem sx={menuItemStyles} onClick={openDownloadAppPage}>
						<MobileIcon />
						Get the app
					</MenuItem>
					<MenuItem sx={menuItemStyles} onClick={handleLogout}>
						<LogoutIcon />
						Log out
					</MenuItem>
				</Box>
				<Box display="flex" justifyContent="center" pb="32px">
					<RainbowButton sx={createButtonStyles} onClick={openCreateEventPage}>
						+ Create event
					</RainbowButton>
				</Box>
			</Box>
		</Popper>
	);
};
